import { App } from 'vue';
import TDesign from 'tdesign-vue-next';
import * as components from './components';
import BaseService, { getInstance } from './base-map/base-service';

import './styles/index.less';

export function install(app: App): void {
  app.use(TDesign);
  Object.keys(components).forEach((key) => {
    app.use(components[key]);
  });
}

export function setConfig(baseDomain: ({ baseMapDomain: string, baseServiceDomain: string })): void {
  const requestInstance = getInstance() || new BaseService();
  requestInstance.setDomain(baseDomain);
}

export * from './components';

export default {
  install,
  setConfig,
};
